import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { BodySchemaModule } from '@bepatient/body-schema';
import { CategoryModule } from '@bepatient/category';
import {
  CORE_BACKEND,
  CoreAppDynamicMenuComponent,
  CoreBackendIDs,
  CoreInitializer,
  CoreModule,
  CorePageModuleIDs,
  ENVIRONMENT,
  getForAppInitializer
} from '@bepatient/core';
import { EventsModule } from '@bepatient/events';
import { FactsheetModule } from '@bepatient/factsheet';
import { HelpModule } from '@bepatient/help';
import { InstanceDynModule } from '@bepatient/instance-dyn';
import { MenuModule } from '@bepatient/menu';
import { MessagesModule } from '@bepatient/messages';
import { MyAccountModule } from '@bepatient/my-account';
import { MyFormModule } from '@bepatient/my-form';
import { MyFormsListModule } from '@bepatient/my-forms-list';
import { MyMeasuresModule } from '@bepatient/my-measures';
import { OnboardingModule } from '@bepatient/onboarding';
import { QuizzModule } from '@bepatient/quizz';
import { TakeMeasureModule } from '@bepatient/take-measure';
import { TimelineModule } from '@bepatient/timeline';
import { EDocsModule } from '@bepatient/edocs';
import { MyEdiaryModule } from '@bepatient/my-ediary';
import { BridgeWebviewModule } from '@bepatient/bridge-webview';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { environment } from '../environments/environment';

@NgModule({
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: 'md',
      menuIcon: 'menu',
      _forceStatusbarPadding: true,
      innerHTMLTemplatesEnabled: true
    }),
    CoreModule.forRoot({
      useGlobalLoading: true,
      rootPageModule: CorePageModuleIDs.TIMELINE
    }),
    HelpModule,
    QuizzModule,
    EventsModule,
    MyFormModule,
    CategoryModule,
    MessagesModule,
    TimelineModule,
    FactsheetModule,
    MyAccountModule,
    BodySchemaModule,
    MyMeasuresModule,
    OnboardingModule,
    InstanceDynModule,
    MyFormsListModule,
    TakeMeasureModule,
    EDocsModule,
    MyEdiaryModule,
    BridgeWebviewModule,
    MenuModule
  ],
  providers: [
    CoreInitializer,
    { provide: ENVIRONMENT, useValue: environment },
    {
      provide: CORE_BACKEND,
      useValue: CoreBackendIDs.SMART
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideAppInitializer(() => {
      const initializerFn = getForAppInitializer(inject(CoreInitializer));
      return initializerFn();
    })
  ],
  bootstrap: [CoreAppDynamicMenuComponent]
})
export class AppModule {}
